import { formatDurationLabel } from 'features/schedulingEngine/constants/participantSession'
import { INSTRUMENT_EMPTY_VALUE } from './constants'

const formatSaveAndResume = save => {
  if (!save?.enabled) return 'Save & resume: No'
  const minutes = save.minutes ?? save.within_minutes
  const unit = save.unit || 'minutes'
  if (minutes == null) return 'Save & resume: Yes'
  return `Save & resume: ${formatDurationLabel(minutes, unit)}`
}

const formatEditAfterSubmission = edit => {
  if (!edit?.enabled) return 'Edit after submission: No'
  if (edit.until_expires) return 'Edit after submission: Until instance expires'
  if (edit.no_limit) return 'Edit after submission: No time limit'
  const hours = edit.hours ?? edit.within_hours
  const unit = edit.unit || 'hours'
  if (hours == null) return 'Edit after submission: Yes'
  return `Edit after submission: ${formatDurationLabel(hours, unit)}`
}

/** Plain label from scheduling-engine `instance_permissions` API object. */
export const getInstancePermissionsResumeEditLabel = (instancePermissions = null) => {
  if (!instancePermissions || typeof instancePermissions !== 'object') return INSTRUMENT_EMPTY_VALUE
  const save = instancePermissions.save_and_resume || instancePermissions.saveResume
  const edit = instancePermissions.edit_after_submission || instancePermissions.editAfterSubmission
  if (!save && !edit) return INSTRUMENT_EMPTY_VALUE
  return [formatSaveAndResume(save || {}), formatEditAfterSubmission(edit || {})].join('; ')
}
